import { MediaFile } from 'components/organisms/MediaUpload/MediaUpload.types'

const mediaFileToFile = async (mediaFile: MediaFile): Promise<File> => {
  if (!mediaFile.content) {
    throw new Error('MediaFile content is null')
  }

  // Decode base64 to binary data
  const byteCharacters = atob(mediaFile.content)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    byteArrays.push(new Uint8Array(byteNumbers))
  }

  const blob = new Blob(byteArrays, { type: mediaFile.mimetype })
  return new File([blob], mediaFile.filename, { type: mediaFile.mimetype })
}

export default mediaFileToFile
